module.exports = __webpack_public_path__ + "static/media/JW-marriot09.a412f8b0.jpg";